import type { dash_notification_plat } from "@dropbox/api-v2-client";
import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";
import * as rx from "rxjs";
import type { DashNotification } from "./data/notifications";
import type { Service } from "./service";
import type { DNPCategoryName } from "./service/api";

const notificationsService = services.get<Service>(ServiceId.NOTIFICATIONS);

export default notificationsService;

export function listInitialNotifications() {
  // We don't show the full list in the UI yet so we only need to load the first page
  return rx.firstValueFrom(notificationsService.listInitialNotifications());
}

export function startPeriodicRefreshNotifications(): Promise<void> {
  return rx.firstValueFrom(
    notificationsService.startPeriodicRefreshNotifications(),
  );
}

export function stopPeriodicRefreshNotifications(): Promise<void> {
  return rx.firstValueFrom(
    notificationsService.stopPeriodicRefreshNotifications(),
  );
}

export function ackNotification(notification: DashNotification) {
  return rx.firstValueFrom(notificationsService.ackNotification(notification));
}

export function markNotificationDismissed(
  notification: DashNotification,
  isAutoDismiss: boolean,
) {
  return rx.firstValueFrom(
    notificationsService.markNotificationDismissed(notification, isAutoDismiss),
  );
}

export function selectNotificationAction(
  notification: DashNotification,
  action: dash_notification_plat.ActionTargetId,
) {
  return rx.firstValueFrom(
    notificationsService.selectNotificationAction(notification, action),
  );
}

export function subscribeToNotifications(
  callback: (notifications: DashNotification[]) => void,
) {
  return notificationsService
    .loudNotificationObservable()
    .subscribe((data) => callback(data.notifications));
}

export function getAllDNPPreferences(): Promise<
  dash_notification_plat.DNPPreference[] | null
> {
  return rx.firstValueFrom(notificationsService.getAllDNPPreferences());
}

export function setDNPPreference(
  dnpCategoryName: DNPCategoryName,
  isSubscribed: boolean,
): Promise<boolean> {
  return rx.firstValueFrom(
    notificationsService.setDNPPreference(dnpCategoryName, isSubscribed),
  );
}
